<template>
    <div class="search-bar-wrapper">
        <div class="search-bar">
            <span class="title">遇见文物</span>
            <div class="input-wrapper">
                <input 
                    v-model="keyword" 
                    type="text" 
                    placeholder="搜索关键词"
                    @focus="handleFocus"
                    @input="handleInput"
                />
            </div>
            <button class="search-btn" @click="handleSearch">
                <img src="@/assets/imgs/icon78.png" alt="搜索">
            </button>
        </div>
        
        <!-- 搜索建议下拉框 -->
        <div class="suggestions" v-if="showSuggestions && suggestions.length > 0">
            <div 
                class="suggestion-item" 
                v-for="(item, index) in suggestions" 
                :key="index"
                @click="selectSuggestion(item)"
            >
                {{ item.title || item.name || item }}
            </div>
        </div>
        
        <!-- 空状态提示 -->
        <div class="suggestions" v-if="showSuggestions && keyword && suggestions.length === 0 && !loading">
            <div class="suggestion-item no-data">暂无相关推荐</div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { http } from '@/request/http'

const props = defineProps({
    modelValue: {
        type: String,
        default: ''
    },
    placeholder: {
        type: String,
        default: '搜索关键词'
    },
    searchApi: {
        type: String,
        default: '/app-api/promotion/article/search-suggestions'
    }
})

const emit = defineEmits(['update:modelValue', 'search'])

const keyword = ref(props.modelValue)
const suggestions = ref([])
const showSuggestions = ref(false)
const loading = ref(false)
let debounceTimer = null

watch(() => props.modelValue, (newVal) => {
    keyword.value = newVal
})

watch(keyword, (newVal) => {
    emit('update:modelValue', newVal)
})

// 防抖处理
const debounce = (fn, delay = 300) => {
    return (...args) => {
        if (debounceTimer) clearTimeout(debounceTimer)
        debounceTimer = setTimeout(() => {
            fn(...args)
        }, delay)
    }
}

// 获取搜索建议
const fetchSuggestions = async (value) => {
    if (!value || value.trim() === '') {
        suggestions.value = []
        showSuggestions.value = false
        return
    }

    loading.value = true
    try {
        // 通用搜索建议接口 - 可以根据实际后端接口调整
        const res = await http.get('/app-api/product/spu/page?pageNo=1&pageSize=5&createTime=1&type=1&sortAsc=false&name='+encodeURIComponent(value))
        suggestions.value = res.list || res.rows || res.data || []
        showSuggestions.value = true
    } catch (error) {
        console.error('获取搜索建议失败:', error)
        suggestions.value = []
    } finally {
        loading.value = false
    }
}

const debouncedFetch = debounce(fetchSuggestions, 300)

const handleInput = (e) => {
    const value = e.target.value
    keyword.value = value
    if (value) {
        debouncedFetch(value)
    } else {
        suggestions.value = []
        showSuggestions.value = false
    }
}

const handleFocus = () => {
    if (suggestions.value.length > 0) {
        showSuggestions.value = true
    }
}

var selectedId = ref('')
const selectSuggestion = (item) => {
    const text = item.title || item.name || item
    keyword.value = text
    showSuggestions.value = false
    // emit('search', item.id)
    selectedId.value = item.id
}

const handleSearch = () => {
    showSuggestions.value = false
    emit('search', selectedId.value)
}



// 点击外部关闭建议列表
const handleClickOutside = (e) => {
    const wrapper = document.querySelector('.search-bar-wrapper')
    if (wrapper && !wrapper.contains(e.target)) {
        showSuggestions.value = false
    }
}

onMounted(() => {
    document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside)
    if (debounceTimer) clearTimeout(debounceTimer)
})
</script>

<style scoped lang="scss">
.search-bar-wrapper {

}

.search-bar {
    display: flex;
    align-items: center;
    background-color: #f5f5f5;
    border-radius: 15rem;
    height: 30rem;
    margin: 25rem 15rem 15rem 15rem;
    padding: 0 0 0 15rem;
    overflow: hidden;
   
    .title {
        font-size: 12rem;
        color: #333;
        font-weight: bold;
        flex-shrink: 0;
        margin-right: 10rem;
        border-right: 1px solid #ccc;
        padding-right: 10rem;
        color: #555555;
    }

    .input-wrapper {
        flex: 1;
        input {
            width: 100%;
            border: none;
            background: transparent;
            color: #333;
            outline: none;
            font-size: 12rem;
            line-height: 20rem;

            &::placeholder {
                color: #999;
            }
        }
    }

    .search-btn {
        width: 40rem;
        height: 32rem;
        border: none;
        background: transparent;
        padding: 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #726FF9;
        
        img {
            width: 16rem;
            height: 16rem;
        }
    }
}

.suggestions {
    position: absolute;
    top: 100%;
    left: 15rem;
    right: 15rem;
    background-color: #fff;
    border-radius: 8rem;
    box-shadow: 0 4rem 12rem rgba(0, 0, 0, 0.15);
    max-height: 240rem;
    overflow-y: auto;
    margin-top: 5rem;

    .suggestion-item {
        padding: 10rem 15rem;
        font-size: 13rem;
        color: #333;
        border-bottom: 1px solid #f0f0f0;
        cursor: pointer;
        transition: background-color 0.2s;

        &:last-child {
            border-bottom: none;
        }

        &:hover {
            background-color: #f5f5f5;
        }

        &.no-data {
            color: #999;
            text-align: center;
            cursor: default;
            
            &:hover {
                background-color: #fff;
            }
        }
    }
}
</style>
